<template>
  <DashboardCard
    heading="Påløpt, ubetalt produktforbruk"
    iconClass="budicon-notepad-list"
    :loading="isLoading"
    :showMessage="showError"
    :message="errorMessage"
  >
    <template v-if="hasUninvoicedFees">
      <div class="myPageUninvoicedFees__proData">
        <ReportsDashboardMetric
          :value="totalUninvoicedAmount"
          format="currency"
          legend="Påløpt, ubetalt beløp"
          small
        />
        <ReportsDashboardMetric :value="totalUninvoicedCount" legend="Antall produkter" small />
      </div>

      <div class="myPageUninvoicedFees__overviewWrapper mypage-cta text-center">
        <router-link :to="{ name: 'uninvoiced_fees_details' }" class="btn btn-sm btn-outline-secondary">
          Se oversikt
          <i class="budicon budicon-arrow-right"></i>
        </router-link>
      </div>
    </template>

    <p v-else>Ingen produktforbruk registrert</p>
  </DashboardCard>
</template>

<script>
import DashboardCard from '@/components/DashboardCard';
import ReportsDashboardMetric from '@/components/reports/dashboard/ReportsDashboardMetric';
import { ProfilesLandlordApi } from '@modules/husleieapi2';
import { mapGetters } from 'vuex';

export default {
  components: {
    ReportsDashboardMetric,
    DashboardCard,
  },
  props: {
    errorMessage: {
      type: String,
      default: 'Kunne ikke laste produktforbruk',
    },
  },
  data() {
    return {
      isLoading: false,
      showError: false,
      uninvoicedFeesData: null,
    };
  },
  computed: {
    ...mapGetters({
      landlordProfiles: 'getLandlordProfilesMeta',
    }),
    hasLandlordAccess() {
      return this.landlordProfiles && this.landlordProfiles.length > 0;
    },
    hasUninvoicedFees() {
      return this.uninvoicedFeesData && this.totalUninvoicedCount > 0;
    },
    totalUninvoicedAmount() {
      if (!this.uninvoicedFeesData) return 0;

      // Aggregate total from all landlords
      return this.uninvoicedFeesData.reduce((total, landlordData) => {
        return total + (landlordData.totalAmount || 0);
      }, 0);
    },
    totalUninvoicedCount() {
      if (!this.uninvoicedFeesData) return 0;

      // Count all fees across all landlords
      return this.uninvoicedFeesData.reduce((total, landlordData) => {
        return total + (landlordData.totalRows || 0);
      }, 0);
    },
  },
  watch: {
    hasLandlordAccess: {
      handler(value) {
        if (value) {
          this.fetchUninvoicedFees();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async fetchUninvoicedFees() {
      if (!this.hasLandlordAccess) return;

      this.isLoading = true;
      this.showError = false;

      try {
        const api = new ProfilesLandlordApi();
        const response = await api.getProfileLandlordsUninvoicedFees();

        this.uninvoicedFeesData = response;
      } catch (error) {
        // Error fetching uninvoiced fees
        this.showError = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.myPageUninvoicedFees__proData {
  @apply mt-4 grid grid-cols-2;
}

.myPageUninvoicedFees__overviewWrapper {
  @apply mt-4;
}
</style>
